module.exports = __webpack_public_path__ + "static/media/Allfresco-Semillas-a-granel.64126c72.jpg";